// extracted by mini-css-extract-plugin
module.exports = {"photo":"invite-list_photo__2uRrC","name":"invite-list_name__3A_9g","email":"invite-list_email__1BbT5","cost":"invite-list_cost__3XdQs"};